export default {
    limitRules: [],
    limitRuleDetail: {},
    wareLists: [],
    areaLists: [],  //限购区域列表
    form: {
        ruleName: '',  //限购规则名称
        restrictRange: 1, // 限购区域 1:全国 2：指定区域
        areaCodeList: [],  //指定区域集合
        beginRestrictTime: '', //限购日期-开始日期
        endRestrictTime: '',  //限购日期-结束日期
        restrictPinCount: 1, //限购数量
        skuList: [],  //限购商品skuid
        ruleType: 1  //限购类型 1:限购 2:起订
    },
    selectedWare: [], //选中的限购商品
    selectedArea: [], //选中的限购区域
    isRefreshWare: false,    //是否重新刷商品数据（为了清空上次选中的效果）
}


// WEBPACK FOOTER //
// ./src/store/limit-sale/state.js